import {Button, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import StanWL from './StanWL';

const {Paragraph} = Typography;
const {Content} = Layout;

const StanWLTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
    }
  };
  const items_ = [
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Calibration Curve with ELONA</Button>, key: 'uno', children: <StanWL/>},
  ];
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Correlation between aptamer/biomarker concentration and colorimetric signal</Paragraph>
      <Content style={{padding: '2vh', background: 'transparent', marginTop: '-10vh'}}>
        <Tabs
          tabBarGutter='4vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default StanWLTabs;
